<template>
    <div>
        <div v-if="editable">
            <button class="col-12 col-md-auto pull-right btn btn-default ml-2 mb-3" @click="getModulesTrigger++"
                    data-toggle="modal" data-target="#modal_new">
                {{ $lang('Dodaj moduł') }}
            </button>

            <button v-if="modules !== []" type="button" v-on:click="updateAll"
                    class="col-12 col-md-auto pull-right btn btn-default">
                {{ $lang('Przedłuż wszystko o rok') }}
            </button>
        </div>

        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
        <table class="table simple-table table-striped table-sm mb-0">
            <thead class="thead-dark">
            <tr>
                <th scope="col">{{ $lang('Nazwa') }}</th>
                <th scope="col">{{ $lang('Typ') }}</th>
                <th scope="col">{{ $lang('Wartość') }}</th>
                <th scope="col">{{ $lang('Data wygaśnięcia') }}</th>
                <th scope="col" v-if="editable">{{ $lang('Akcje') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="pagination.total===0" class="table-light">
                <th>
                    {{ $lang('Brak danych') }}
                </th>
            </tr>
            <tr v-else v-for="module in modules">
                <td :data-title="$lang('Nazwa')">
                    {{ module.name || "-" }}
                </td>
                <td :data-title="$lang('Typ')">{{ module.module.type.showable_name || "-" }}</td>
                <td :data-title="$lang('Wartość')">{{ module.value }}</td>
                <td :data-title="$lang('Data wygaśnięcia')">{{ module.expired_showable }}</td>
                <td v-if="editable">
                    <a class="mr-3" href="#" data-toggle="modal" v-on:click="editedModule=module"
                       data-target="#delete_module_modal">{{ $lang('Usuń') }}</a>
                    <a class="mr-3" href="#" data-toggle="modal" v-on:click="editedModule=module"
                       data-target="#edit_module_modal">{{ $lang('Edytuj') }}</a>
                </td>
            </tr>
            </tbody>
        </table>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>

        <library-module-new
            :get_modules_route="get_modules_route"
            :url="add_route"
            :trigger="getModulesTrigger"
            :trade_module_types="trade_module_types"
            :default_new_date="default_new_date"
        ></library-module-new>
        <library-module-delete
            :module=editedModule
            :delete_route="delete_route"
        ></library-module-delete>
        <library-module-edit
            :url="edit_route"
            :module="editedModule"
            :trade_module_types="trade_module_types"
        ></library-module-edit>
    </div>
</template>

<script>
import LibraryModuleEdit from "./library-module-edit";
import LibraryModuleNew from "./library-module-new";
import {EventBus} from "../../mixins/event-bus";
import LibraryModuleDelete from "./library-module-delete";

export default {
    name: 'library-modules',
    components: {LibraryModuleDelete, LibraryModuleEdit, LibraryModuleNew, EventBus},
    props: ['editable', 'user', 'get_data_route', 'edit_route', 'edit_all_route', 'add_route', 'delete_route', 'get_modules_route', 'trade_module_types'],
    data() {
        return {
            pagination: [],
            getModulesTrigger: 0,
            modules: [],
            editedModule: null,
            tableFields: [
                {
                    key: 'name',
                    label: 'Nazwa',
                    sortable: true,
                },
                {
                    key: 'type.showable_name',
                    label: 'Typ',
                    sortable: true,

                },
                {
                    key: 'value',
                    label: 'Wartość',
                    sortable: true,

                },
                {
                    key: 'expired_showable',
                    label: 'Data wygaśnięcia',
                    sortable: true
                }
            ],
            default_new_date: "-"
        }
    },
    methods: {
        getUserModules() {
            console.log("porano moduly")
            const self = this;
            axios.get(this.get_data_route)
                .then(function (response) {
                    self.modules = response.data.data;
                    self.pagination = response.data;
                    if (response.data.data.length > 0) {
                        console.log("Ustawiono datę")
                        self.default_new_date = response.data.data[0].expired;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        deleteModule(id) {
            let self = this;
            axios.post(this.delete_route, {
                id: id
            })
                .then(function () {
                    self.getUserModules();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        updateAll() {
            let self = this;
            axios.post(this.edit_all_route)
                .then(function () {
                    self.getUserModules();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    },
    created() {
        this.getUserModules();
        if (this.editable) {
            this.tableFields.push({
                key: 'actions',
                label: 'Akcje'
            });
        }
    }
}
</script>
